const _import = require("@/libs/util.import." + process.env.NODE_ENV)
export const routerName = {
  913: {
    path: "/contentManager",
    name: "contentManager",
    meta: {
      title: "内容管理",
      authId: "913",
      parentId: "1",
      cache: false
    }
  },
  91301: {
    path: "/contentManagerList",
    name: "contentManagerList",
    meta: {
      title: "内容管理",
      authId: "91301",
      parentId: "913",
      cache: false
    },
    auth: [
      {
        authId: "9130101",
        parentId: "91301",
        label: "新增内容",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "91302",
            name: "新增内容",
            parentId: "91301"
          }
        ]
      },
      {
        authId: "9130102",
        parentId: "91301",
        label: "查看",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "91303",
            name: "查看",
            parentId: "91301"
          }
        ]
      },
      {
        authId: "9130103",
        parentId: "91301",
        label: "统计",
        handle: "goStatisticsPage",
        addRoutePath: [
          {
            authId: "91304",
            name: "统计",
            parentId: "91301"
          }
        ]
      },
      {
        authId: "9130104",
        parentId: "91301",
        label: "批量启用",
        category: "Button",
        handle: "mutiStart"
      },
      {
        authId: "9130105",
        parentId: "91301",
        label: "批量停用",
        category: "Button",
        handle: "mutiStop"
      },
      {
        authId: "9130106",
        parentId: "91301",
        label: "编辑",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "91302",
            name: "新增内容",
            parentId: "91301"
          }
        ]
      },
      {
        authId: "9130107",
        parentId: "91301",
        label: "删除",
        handle: "handleDel"
      },
      {
        authId: "9130108",
        parentId: "91301",
        label: "启用",
        handle: "operatStatus",
        ruleObj: {
          attr: "status",
          rule: {
            2: "启用",
            1: "停用"
          }
        }
      }
    ],
    component: _import("contentManager/contentManagerList")
  },
  91302: {
    path: "/contentAdd",
    name: "contentAdd",
    meta: {
      title: "内容编辑",
      authId: "91302",
      parentId: "91301",
      cache: false,
      activePath: "/contentManagerList"
    },
    component: _import("contentManager/contentAdd")
    // component: _import("contentManager/SopContentAdd")
  },
  91303: {
    path: "/contentDetail",
    name: "contentDetail",
    meta: {
      title: "查看",
      authId: "91303",
      parentId: "91301",
      cache: false,
      activePath: "/contentManagerList"
    },
    component: _import("contentManager/contentDetail")
  },
  91304: {
    path: "/statisticsList",
    name: "statisticsList",
    meta: {
      title: "统计",
      authId: "91304",
      parentId: "91301",
      cache: false,
      activePath: "/contentManagerList"
    },
    auth: [
      {
        authId: "9130401",
        parentId: "91304",
        label: "导出",
        category: "Button",
        handle: "exportList"
      }
    ],
    component: _import("contentManager/statisticsList")
  },

  91305: {
    path: "/staffMassSending",
    name: "staffMassSending",
    meta: {
      title: "员工群发",
      authId: "91305",
      parentId: "913",
      cache: false
    },
    auth: [
      {
        authId: "9130501",
        parentId: "91305",
        label: "新增群发",
        icon: "plus",
        category: "Button",
        type: "primary",
        handle: "handleAdd",
        addRoutePath: [
          {
            authId: "91306",
            name: "内容编辑",
            parentId: "91305"
          }
        ]
      },
      {
        authId: "9130502",
        parentId: "91305",
        label: "查看",
        handle: "handleDetail",
        addRoutePath: [
          {
            authId: "91307",
            name: "查看",
            parentId: "91305"
          }
        ]
      },
      {
        authId: "9130503",
        parentId: "91305",
        label: "编辑",
        handle: "handleAdd"
      },
      {
        authId: "9130504",
        parentId: "91305",
        label: "统计",
        handle: "goStatisticsPage",
        addRoutePath: [
          {
            authId: "9130506",
            name: "统计",
            parentId: "91305"
          }
        ]
      },
      {
        authId: "9130505",
        parentId: "91305",
        label: "删除",
        handle: "handleDel"
      }
    ],
    component: _import("contentManager/staffMassSending/index")
  },

  9130506: {
    path: "/statisticsPage",
    name: "statisticsPage",
    meta: {
      title: "统计",
      authId: "9130506",
      parentId: "91305",
      cache: false,
      activePath: "/statisticsPage"
    },
    auth: [
      {
        authId: "913050601",
        parentId: "9130506",
        label: "导出",
        category: "Button",
        type: "primary",
        handle: "handleExport"
      }
    ],
    component: _import("contentManager/staffMassSending/statisticsPage")
  },
  91306: {
    path: "/SopContentAdd",
    name: "SopContentAdd",
    meta: {
      title: "内容编辑",
      authId: "91306",
      parentId: "91301",
      cache: false,
      activePath: "/staffMassSending"
    },
    component: _import("contentManager/SopContentAdd")
  },
  91307: {
    path: "/sopContentDetail",
    name: "sopContentDetail",
    meta: {
      title: "查看",
      authId: "91307",
      parentId: "91301",
      cache: false,
      activePath: "/staffMassSending"
    },
    component: _import("contentManager/sopContentDetail")
  },
  91308: {
    path: "/productEntry",
    name: "productEntry",
    meta: {
      title: "产品词条",
      authId: "91308",
      parentId: "913",
      cache: false
    },
    auth: [],
    component: _import("contentManager/productEntry/index")
  },
  91309: {
    path: "/packageConfig",
    name: "packageConfig",
    meta: {
      title: "平板配置",
      authId: "91309",
      parentId: "913",
      cache: false
    },
    auth: [],
    component: _import("contentManager/packageConfig/index")
  },
  91310: {
    path: "/packageEdit",
    name: "packageEdit",
    meta: {
      title: "素材配置",
      authId: "91310",
      parentId: "91309",
      cache: false
    },
    auth: [],
    component: _import("contentManager/packageConfig/edit")
  },
  91315: {
    path: "/customerTags",
    name: "customerTags",
    meta: {
      title: "客户标签",
      authId: "91315",
      parentId: "913",
      cache: false
    },
    auth: [],
    component: _import("contentManager/customerTags/index")
  },
  91317: {
    path: "/customerFile",
    name: "customerFile",
    meta: {
      title: "客户档案",
      authId: "91317",
      parentId: "913",
      cache: false
    },
    auth: [],
    component: _import("contentManager/customerFile/index")
  },
  9131701:{
    path: "/customerFileDetails",
    name: "customerFileDetails",
    meta: {
      title: "话术管理",
      authId: "9131701",
      parentId: "91317",
      cache: false
    },
    auth: [],
    component: _import("contentManager/customerFile/customerFileDetails")
  }
}
